import clsx from "clsx"
import { FC, memo, useMemo } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useGame } from "@/providers/GameProvider"
import { IEffectActivatedLog } from "@/store/apis/gameplayAPI"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./LogEffectActivated.module.scss"

const LogEffectActivatedComponent: FC<IEffectActivatedLog> = (props) => {
  const { t } = useTranslation()
  const { isMe, playerName, opponentName } = useGame()

  const text = useMemo(() => {
    const {
      effectType,
      isApplied,
      duration,
      playerTarget,
      probabilityPercentage
    } = props.details

    const isMePlayer = isMe(playerTarget, props.currentPlayer)

    const name = (
      <OutlinedText
        className={clsx({
          "green-light": isMePlayer,
          "red-light": !isMePlayer
        })}
      >
        {isMePlayer ? playerName : opponentName}
      </OutlinedText>
    )
    const rival = (
      <OutlinedText
        className={clsx({
          "green-light": !isMePlayer,
          "red-light": isMePlayer
        })}
      >
        {isMePlayer ? opponentName : playerName}
      </OutlinedText>
    )

    // switch (props.details.effectType) {
    //   case "skip_dig":
    //     return (
    //       <>
    //         {getPlayerActionNameKey(
    //           isMe(props.details.playerTarget),
    //           "possessive",
    //         )}{" "}
    //         skip digging effect{" "}
    //         <span className="orange">
    //           <span>({duration})</span>
    //         </span>
    //       </>
    //     )
    // }

    return (
      <>
        <Trans
          i18nKey={
            isApplied
              ? "logs.effectActivated.default.success"
              : "logs.effectActivated.default.failed"
          }
          components={{
            span: <span />,
            orange: <span className="orange" />,
            effect: (
              <span
                className={clsx({
                  green: isApplied,
                  red: !isApplied
                })}
              />
            ),
            name: name,
            rival: rival
          }}
          values={{
            effectType: t(`effect_types.${effectType}.title`),
            probabilityPercentage,
            duration,
            turnWord: t("turn", { count: duration })
          }}
        />
      </>
    )
  }, [props])

  return <span className={clsx(styles.LogEffectApplied)}>{text}</span>
}

export const LogEffectActivated = memo(LogEffectActivatedComponent)
